var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsset30(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147.71 147.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e025f4;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #a029ed;\n      }\n\n      .cls-3 {\n        fill: #3b2447;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 23.66,
    y: 22.4,
    width: 100.96,
    height: 100.96
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 37.72,
    cy: 112.5,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 62,
    cy: 85.31,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 86.29,
    cy: 85.31,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 110.57,
    cy: 85.31,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 86.29,
    cy: 112.5,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 110.57,
    cy: 112.5,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 37.72,
    cy: 59.33,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 62,
    cy: 59.33,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 110.57,
    cy: 59.33,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 62,
    cy: 33.35,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 37.72,
    cy: 33.35,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 110.57,
    cy: 33.35,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 86.29,
    cy: 59.33,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 86.29,
    cy: 33.35,
    rx: 5.59,
    ry: 5.24
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "147.71 0 147.71 147.03 68.73 147.03 68.73 137.21 137.76 137.21 137.76 9.95 10.52 9.95 10.52 78.98 .64 78.98 .64 0 147.71 0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 52.92,
    cy: 142.06,
    rx: 5.62,
    ry: 5.27
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 5.62,
    cy: 93.45,
    rx: 5.62,
    ry: 5.27
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset30);
export default __webpack_public_path__ + "static/media/Asset 30.2d39270f7f8e81fcd53063cbad991dab.svg";
export { ForwardRef as ReactComponent };